import script from "./account-label.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./account-label.vue?vue&type=script&setup=true&lang=js"
export * from "./account-label.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./account-label.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__